var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import get from "lodash/get";
import set from "lodash/set";
import size from "lodash/size";
import pick from "lodash/pick";
import merge from "lodash/merge";
import { getUniqueCartItemsByKey } from "./helpers";
import { normalizeDefaultBillReceiverIndex, normalizeDefaultFormData } from "../components/BookingForm/booking-form.helpers";
import { normalizeDate, dateToString } from "../helpers/date";
import isNil from "lodash/isNil";
var FormState = /** @class */ (function () {
    function FormState(modelManager, dirtyForm, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        this.modelManager = modelManager;
        this.dirtyForm = dirtyForm;
        this.options = options;
        // All Cart Items
        this._cartItems = [];
        // Participant Indices
        this.defaultParticipantIndices = null;
        this._participantIndices = {};
        // Bill Recipient
        this._billRecipientIndex = null;
        // Has Separate Bill Recipient
        this._hasSeparateBillRecipient = (_a = get(this.options, "defaultFormData.booking_data.has_separate_bill_data")) !== null && _a !== void 0 ? _a : get(this.dirtyForm, "booking_data.has_separate_bill_data", false);
        // Booking Slot
        this._bookingSlot = undefined;
        // intermittent state to show the checkout step as multiple forms
        this.hasDifferingParticipants = get(this.dirtyForm, "hasDifferingParticipants", false);
        this._defaultValues = {};
        var isAdmin = this.options.isAdminIntegration;
        this.customerIdParticipant = get(this.dirtyForm, "customerIdParticipant", "");
        this.customerId = get(this.dirtyForm, "customerId", "");
        var defaultdata = this.getDefaultData();
        this.categoryNames = this.deriveCategories();
        this.placeName = this.derivePlaceName();
        this.bookingId = get(this.options, "takeBookingId", true) ? get(defaultdata, "booking_data.booking_id", null) : null;
        // this.bookingSlot = get(defaultdata, "booking_data.booking_slot", this.bookingSlot);
        var selectedCartItems = get(this.dirtyForm, "booking_data.cart_items");
        var defaultCartItems = get(defaultdata, "booking_data.cart_items", []);
        this.cartItems = (defaultCartItems === null || defaultCartItems === void 0 ? void 0 : defaultCartItems.length) && !(selectedCartItems === null || selectedCartItems === void 0 ? void 0 : selectedCartItems.length) ? this.normalizeDefaultFormData(defaultdata).booking_data.cart_items : (selectedCartItems || this.normalizeDefaultFormData(defaultdata).booking_data.cart_items);
        this.billRecipientIndex = get(defaultdata, "booking_data.bill_receiver_index") || get(this.dirtyForm, "booking_data.bill_receiver_index", null);
        this.adminConfigToggles = get(this.options, "adminSettings.admin_config_toggles") || get(this.dirtyForm, "admin_config_toggles", {});
        this.additional_props = merge({}, defaultdata === null || defaultdata === void 0 ? void 0 : defaultdata.additional_props, get(this.dirtyForm, "additional_props"));
        this.hasCoworkerConsent = isAdmin ? get(dirtyForm, "booking_data.coworker_confirms_consents", false) : undefined;
        this.form_data = {
            form_field: {
                course_participants: [],
                personal_data: [],
                extra_columns: [],
            },
            consent_agreement: {
                consents: {}
            },
            form_group: {}
        };
        if (!size(get(this.dirtyForm, "form_data"))) {
            var customerId = isAdmin && !this.customerId && ((_c = (_b = this.getDefaultData()) === null || _b === void 0 ? void 0 : _b.booking_data) === null || _c === void 0 ? void 0 : _c.customer_id) ? String(((_e = (_d = this.getDefaultData()) === null || _d === void 0 ? void 0 : _d.booking_data) === null || _e === void 0 ? void 0 : _e.customer_id) || "") : (this.customerId || "");
            this.customerId = customerId;
            var isDefaultData = (this.bookingId && Number(customerId) === ((_g = (_f = this.options.defaultFormData) === null || _f === void 0 ? void 0 : _f.booking_data) === null || _g === void 0 ? void 0 : _g.customer_id));
            var hasCustomerLoaded = !isAdmin || isDefaultData || !this.isLoadingCustomerData;
            var normalizedDefaultData = !isAdmin ? defaultdata : (isDefaultData ? this.options.defaultFormData : this.getSelectedCustomerData());
            var participantIndices = isDefaultData && this.bookingId ? [].concat(get(this.options.defaultFormData, "booking_data.cart_items.0.booking.personal_data_index")).map(String) : null;
            this.defaultParticipantIndices = isAdmin ? this.options.takeDirtyIndices ? get(this.cartItems, "0.booking.personal_data_index") || participantIndices : participantIndices : null;
            this.customerIdParticipant = participantIndices ? this.customerId + "_" + participantIndices[0] : this.customerIdParticipant;
            this.form_data = hasCustomerLoaded ? merge(this.form_data, get(normalizedDefaultData, "form_data")) : this.form_data;
        }
        this.booking_data = this.getBookingData();
    }
    Object.defineProperty(FormState.prototype, "rootCartItems", {
        // Root Items of each Timespan
        get: function () {
            return this.cartItems.filter(function (cartItem) { return cartItem.isRoot; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "availableRootCartItems", {
        // Root Items of each Timespan
        get: function () {
            return this.cartItems.filter(function (cartItem) { return cartItem.isRoot && !cartItem.isBookedOut; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "extraArticleCartItems", {
        // Extra Course timespans booked
        get: function () {
            return this.cartItems.filter(function (cartItem) { return cartItem.isExtraArticle; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "extraPrices", {
        // Extra Course timespans and extra prices booked
        get: function () {
            return this.cartItems.filter(function (cartItem) { return !cartItem.isRoot; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "filteredCartItems", {
        // filter out booked out cart items
        get: function () {
            return this.cartItems.filter(function (cartItem) { return !cartItem.isBookedOut; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "extraPricesAsHash", {
        // KeyValuePairs: Extra Course timespans and extra prices booked
        get: function () {
            return getUniqueCartItemsByKey(this.modelManager, this.extraPrices);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "cartItems", {
        get: function () {
            return this._cartItems;
        },
        set: function (cartItems) {
            this._cartItems = cartItems;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "participants", {
        // Participants
        get: function () {
            return this.form_data.form_field.personal_data;
        },
        set: function (participants) {
            this.form_data.form_field.personal_data = participants;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "participantDataToSave", {
        get: function () {
            var _a, _b;
            return merge({
                form_data: {
                    form_field: {
                        extra_columns: (_a = this.form_data.form_field.extra_columns) === null || _a === void 0 ? void 0 : _a.map(function (participantExtraColumn) { return Array.isArray(participantExtraColumn) ? undefined : participantExtraColumn; }),
                        personal_data: ((_b = this.participants) === null || _b === void 0 ? void 0 : _b.filter(function (participant) { return !["salutation_id", "first_name", "last_name"].some(function (prop) { return !(participant === null || participant === void 0 ? void 0 : participant[prop]); }); })) || []
                    }
                }
            }, pick(this, "additional_props"), { additional_props: { is_saved_participant_form: true }, });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "participantIndices", {
        get: function () {
            return this._participantIndices;
        },
        set: function (indices) {
            this._participantIndices = indices;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "billRecipientIndex", {
        get: function () {
            return this._billRecipientIndex;
        },
        set: function (billRecipientIndex) {
            this._billRecipientIndex = billRecipientIndex;
            this.booking_data = this.getBookingData();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "hasSeparateBillRecipient", {
        get: function () {
            return this._hasSeparateBillRecipient;
        },
        set: function (hasSeparateBillRecipient) {
            this._hasSeparateBillRecipient = hasSeparateBillRecipient;
            this.booking_data = this.getBookingData();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "bookingSlot", {
        get: function () {
            return this._bookingSlot;
        },
        set: function (slot) {
            this._bookingSlot = slot;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "useExistingParticipant", {
        // Should Use existing participant as the bill recipient
        get: function () {
            return this.rootCartItems.every(function (cartItem) { var _a; return (_a = cartItem.timespan) === null || _a === void 0 ? void 0 : _a.useExistingParticipant; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "hasTimespanWithoutParticipantForm", {
        // Participant form to be hidden
        get: function () {
            return this.getCartTimespans(this).some(function (timespan) {
                return !(timespan === null || timespan === void 0 ? void 0 : timespan.shouldCollectParticipantInformation);
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "shouldCollectParticipantInfo", {
        get: function () {
            return this.rootCartItems.some(function (cartItem) { var _a; return (_a = cartItem.timespan) === null || _a === void 0 ? void 0 : _a.shouldCollectParticipantInformation; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "hasTimespanWithBillRecipient", {
        // Bill recipient will be a participant
        get: function () {
            return this.getCartTimespans(this).some(function (timespan) { return (timespan === null || timespan === void 0 ? void 0 : timespan.hasSeparateBillRecipient) && !(timespan === null || timespan === void 0 ? void 0 : timespan.hideSeparateBillReceipient); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "hideSeparateBillReceipient", {
        // Should hide separate bill recipient checkbox
        get: function () {
            return this.rootCartItems.some(function (cartItem) { var _a; return (_a = cartItem.timespan) === null || _a === void 0 ? void 0 : _a.hideSeparateBillReceipient; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "mustHaveDifferingParticipants", {
        // derive if the form should be split by default.
        get: function () {
            var _this = this;
            var cartItems = this.rootCartItems;
            return cartItems.length <= 1
                || cartItems.some(function (cartItem) { return cartItem.quantity !== cartItems[0].quantity; })
                || cartItems.filter(function (cartItem) { var _a; return (_a = cartItem.timespan) === null || _a === void 0 ? void 0 : _a.shouldCollectParticipantInformation; }).length <= 1
                || cartItems.some(function (cartItem) {
                    var _a, _b;
                    return (cartItem.participantFormGroupId !== cartItems[0].participantFormGroupId
                        || ((_a = cartItem.timespan) === null || _a === void 0 ? void 0 : _a.hideSeparateBillReceipient) !== ((_b = cartItems[0].timespan) === null || _b === void 0 ? void 0 : _b.hideSeparateBillReceipient)
                        || _this.getCartItemsByTimespanId(cartItem.timespanId, cartItem.priceId)
                            .some(function (extraPrice) { return extraPrice.isExtraArticle && +extraPrice.quantity > 0; }));
                });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "hasFixedBillRecipient", {
        // Has Fixed Bill Recipient
        // any of the event has participant form to be hidden
        // any of the event has biller form to be hidden
        get: function () {
            return !!this.getFixedBillRecipientFromCart();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "shouldSaveParticipant", {
        get: function () {
            return (this.options.showSaveParticipants && this.additional_props.save_participant_data) || false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormState.prototype, "isLoadingCustomerData", {
        get: function () {
            return !!this.customerId && !this.getSelectedCustomerData();
        },
        enumerable: false,
        configurable: true
    });
    FormState.prototype.isParticipantDisabled = function (index) {
        if (!this.options.isAdminIntegration) {
            return false;
        }
        if (get(this.admin_config_toggles, "disable_customer_personal_data") === true) {
            return false;
        }
        var peronsalData = get(this.getSelectedCustomerData(), "form_data.form_field.personal_data", []);
        if (peronsalData.length <= 0) {
            return false;
        }
        return peronsalData.length > index;
    };
    ;
    Object.defineProperty(FormState.prototype, "admin_config_toggles", {
        get: function () {
            return this.adminConfigToggles;
        },
        enumerable: false,
        configurable: true
    });
    FormState.prototype.getFormDefaultValues = function () {
        return this._defaultValues;
    };
    FormState.prototype.setFormDefaultPathValue = function (path, value) {
        set(this._defaultValues, path, value);
    };
    FormState.prototype.setFormDefaultValues = function (defaultValues) {
        this._defaultValues = defaultValues;
    };
    FormState.prototype.derivePlaceName = function () {
        var _a;
        var placeName = get(this.dirtyForm, "placeName", "");
        if (!placeName) {
            return placeName;
        }
        return ((_a = this.modelManager.places().find("name", placeName)) === null || _a === void 0 ? void 0 : _a.name) || "";
    };
    FormState.prototype.deriveCategories = function () {
        var _this = this;
        var categories = get(this.dirtyForm, "categoryNames", []);
        return categories.filter(function (category) { return _this.modelManager.courses().find("name", category); });
    };
    FormState.prototype.toJSON = function () {
        return merge(this.getFormDefaultValues(), {
            admin_config_toggles: this.adminConfigToggles,
            customerIdParticipant: this.customerIdParticipant,
            bookingId: this.bookingId,
            customerId: this.customerId,
            additional_props: this.additional_props,
            hasFixedBillRecipient: this.hasFixedBillRecipient,
            hasDifferingParticipants: this.dirtyForm.hasDifferingParticipants,
            categoryNames: this.categoryNames,
            placeName: this.placeName,
            booking_data: this.booking_data,
            form_data: this.isLoadingCustomerData ? undefined : this.form_data,
            toWaitList: this.toWaitList,
        });
    };
    Object.defineProperty(FormState.prototype, "toWaitList", {
        get: function () {
            var _a;
            return (_a = this.rootCartItems[0]) === null || _a === void 0 ? void 0 : _a.toWaitList;
        },
        enumerable: false,
        configurable: true
    });
    FormState.prototype.toRequestBody = function () {
        return {
            booking_data: __assign(__assign({}, this.booking_data), this.adminConfigToggles),
            form_data: this.form_data,
        };
    };
    FormState.prototype.getBookingData = function () {
        return __assign({ coworker_confirms_consents: this.hasCoworkerConsent, campaigns: this.options.campaigns, bill_receiver_index: this.billRecipientIndex, has_separate_bill_data: this.hasSeparateBillRecipient, cart_items: this._cartItems }, (this.bookingId ? { booking_id: this.bookingId } : {}));
    };
    // get timespans from cart items.
    FormState.prototype.getCartTimespans = function (state) {
        var _this = this;
        return get(state, "booking_data.cart_items", [])
            .map(function (cartItem) { var _a; return _this.modelManager.courseTimespans().findById((_a = cartItem.booking) === null || _a === void 0 ? void 0 : _a.course_timespan_id); })
            .filter(Boolean);
    };
    FormState.prototype.getSelectedCustomerData = function () {
        return get(this.options.customerData, String(this.customerId));
    };
    FormState.prototype.normalizeSavedParticipantForm = function () {
        var savedForm = get(this.options, "savedParticipantForm") || {};
        if (savedForm === null || savedForm === void 0 ? void 0 : savedForm.booking_data) {
            savedForm === null || savedForm === void 0 ? true : delete savedForm.booking_data;
            set(savedForm, "additional_props.is_saved_participant_form", true);
        }
        return savedForm;
    };
    FormState.prototype.getNormalizedSelectedCustomerData = function () {
        return normalizeDefaultBillReceiverIndex(normalizeDefaultFormData(this.getSelectedCustomerData() || this.options.defaultFormData));
    };
    FormState.prototype.normalizeDefaultFormData = function (dirtyForm) {
        var form = normalizeDefaultBillReceiverIndex(normalizeDefaultFormData(dirtyForm));
        var cartItems = get(form, "booking_data.cart_items", []);
        var tc = this.modelManager.courseTimespans();
        cartItems = cartItems.map(function (item) {
            var _a, _b, _c;
            var _d = (item === null || item === void 0 ? void 0 : item.booking) || {}, from = _d.from, booking = __rest(_d, ["from"]);
            if (!Array.isArray(booking.personal_data_index) && !isNil(booking.personal_data_index)) {
                booking.personal_data_index = [].concat(booking.personal_data_index).map(function (x) { return String(x); });
            }
            if (!from) {
                return __assign(__assign({}, item), { booking: booking });
            }
            if (!booking.course_timespan_id) {
                return __assign(__assign({}, item), { booking: booking });
            }
            if (!((_a = item.position) === null || _a === void 0 ? void 0 : _a.quantity)) {
                return __assign(__assign({}, item), { booking: booking });
            }
            var fromDate = normalizeDate((from === null || from === void 0 ? void 0 : from.date) || from), timespanId = booking.course_timespan_id, bookers_count = (_b = item.position) === null || _b === void 0 ? void 0 : _b.quantity, onDate = dateToString(fromDate, "date"), schedulingTimeslot = (_c = tc.findById(timespanId)) === null || _c === void 0 ? void 0 : _c.getSchedulingSlots({ bookers_count: bookers_count, onDate: onDate }).filter(function (_a) {
                var isAvailable = _a.isAvailable;
                return isAvailable;
            }), bookingSlot = schedulingTimeslot === null || schedulingTimeslot === void 0 ? void 0 : schedulingTimeslot.find(function (_a) {
                var from = _a.from;
                return (from === null || from === void 0 ? void 0 : from.getTime()) === fromDate.getTime();
            });
            if (!(schedulingTimeslot === null || schedulingTimeslot === void 0 ? void 0 : schedulingTimeslot.length)) {
                return __assign(__assign({}, item), { booking: booking });
            }
            return __assign(__assign({}, item), { onDate: onDate,
                booking: booking,
                bookingSlot: bookingSlot });
        });
        return merge({}, form, { booking_data: { cart_items: cartItems } });
    };
    FormState.prototype.getDefaultData = function (notSavedForm) {
        var _a;
        if (notSavedForm === void 0) { notSavedForm = false; }
        var savedParticipantForm = this.normalizeSavedParticipantForm(), form = this.getNormalizedSelectedCustomerData();
        if (notSavedForm) {
            return form;
        }
        if ((_a = this.options) === null || _a === void 0 ? void 0 : _a.isAdminIntegration) {
            return form;
        }
        if (get(form, "booking_data.bill_receiver_index")) {
            return form;
        }
        return savedParticipantForm;
    };
    // get all cart items belonging to one timespan
    FormState.prototype.getCartItemsByTimespanId = function (timespanId, priceId) {
        return this.cartItems.filter(function (cartItem) {
            return priceId
                ? String(cartItem.uniqueParentId) === String(priceId)
                : String(cartItem.timespanId) === String(timespanId);
        });
    };
    FormState.prototype.getFixedBillRecipient = function () {
        var index = get(this.getDefaultData(), "booking_data.bill_receiver_index", null);
        return index === null ? index : String(index);
    };
    FormState.prototype.getFixedBillRecipientFromCart = function () {
        var index = this.getFixedBillRecipient();
        return (index !== null ? "" + index : this.deriveFixedBillRecipientIndexFromCart());
    };
    FormState.prototype.hasSavedParticipantData = function () {
        return get(this.getDefaultData(), "additional_props.is_saved_participant_form", false);
    };
    FormState.prototype.hasDefaultParticipantData = function () {
        return this.getFixedBillRecipient() !== null;
    };
    FormState.prototype.hasParticipantData = function () {
        return this.hasDefaultParticipantData() || this.hasSavedParticipantData();
    };
    // derive fixed bill recipient
    FormState.prototype.deriveFixedBillRecipientIndexFromCart = function () {
        var _a, _b;
        var index = this.rootCartItems.findIndex(function (cartItem) {
            var _a;
            return (_a = cartItem.timespan) === null || _a === void 0 ? void 0 : _a.shouldHideBillRecipient;
        });
        return ((_b = (_a = this.rootCartItems[index]) === null || _a === void 0 ? void 0 : _a.personalDataIndex) === null || _b === void 0 ? void 0 : _b[0]) || null;
    };
    // derive fixed bill recipient from dirty cart
    FormState.prototype.deriveFixedBillRecipientIndexFromDirtyForm = function () {
        var _this = this;
        var _a, _b, _c, _d;
        var hasDefaultData = this.hasParticipantData();
        if (!hasDefaultData) {
            return null;
        }
        var cartItems = ((_a = this.dirtyForm.booking_data) === null || _a === void 0 ? void 0 : _a.cart_items) || [];
        var index = cartItems.findIndex(function (cartItem) {
            var _a, _b, _c;
            if ((_a = cartItem === null || cartItem === void 0 ? void 0 : cartItem.position) === null || _a === void 0 ? void 0 : _a.parent_price_id) {
                return false;
            }
            return (_c = _this.modelManager.courseTimespans().findById((_b = cartItem === null || cartItem === void 0 ? void 0 : cartItem.booking) === null || _b === void 0 ? void 0 : _b.course_timespan_id)) === null || _c === void 0 ? void 0 : _c.shouldHideBillRecipient;
        });
        var billRecipientIndex = (_d = (_c = (_b = cartItems[index]) === null || _b === void 0 ? void 0 : _b.booking) === null || _c === void 0 ? void 0 : _c.personal_data_index) === null || _d === void 0 ? void 0 : _d[0];
        return [null, undefined].includes(billRecipientIndex) || isNaN(billRecipientIndex) ? null : String(billRecipientIndex);
    };
    // derive values from the existing data
    FormState.prototype.derive = function () {
        this.hasSeparateBillRecipient = this.deriveHasSeparateBillRecipient();
    };
    // derive has separate bill recipient
    FormState.prototype.deriveHasSeparateBillRecipient = function () {
        var _this = this;
        var _a, _b;
        var includesBillRecipient = this.rootCartItems
            .some(function (cartItem) { var _a; return (_a = cartItem.personalDataIndex) === null || _a === void 0 ? void 0 : _a.includes(_this.billRecipientIndex); });
        if (this.hasFixedBillRecipient) {
            return !includesBillRecipient;
        }
        if (this.hasTimespanWithoutParticipantForm) {
            return includesBillRecipient;
        }
        if (this.hasTimespanWithBillRecipient) {
            return includesBillRecipient;
        }
        var defaultHasSeparateBillRecipient = this.rootCartItems.length > 1 ? this.hasSeparateBillRecipient : !((_b = (_a = this.rootCartItems[0]) === null || _a === void 0 ? void 0 : _a.timespan) === null || _b === void 0 ? void 0 : _b.useExistingParticipant);
        return get(this.dirtyForm.booking_data, "has_separate_bill_data", !!defaultHasSeparateBillRecipient);
    };
    FormState.prototype.deriveExcludedBillRecipientIndices = function () {
        var _this = this;
        return this.rootCartItems.reduce(function (skippedIndices, cartItem) {
            var _a, _b;
            if (!((_a = cartItem.timespan) === null || _a === void 0 ? void 0 : _a.shouldCollectParticipantInformation)) {
                return skippedIndices;
            }
            if (!_this.hasSeparateBillRecipient && ((_b = cartItem.timespan) === null || _b === void 0 ? void 0 : _b.useExistingParticipant)) {
                return skippedIndices;
            }
            return skippedIndices.concat(cartItem.personalDataIndex);
        }, []);
    };
    FormState.prototype.getInvalidFieldPaths = function (validationErrors) {
        if (!this.rootCartItems.length)
            return [];
        var fields = [this.modelManager.getBillRecipientStep(this, validationErrors, [])].concat(this.modelManager.getParticipantStep(this, validationErrors));
        var getFlattenedRequiredFields = function (allFields, field) {
            if (field.fields)
                return allFields.concat(field.fields.reduce(getFlattenedRequiredFields, []));
            if (!field.required) {
                return allFields;
            }
            return allFields.concat(field.name);
        };
        var form = this;
        return [].concat(fields).reduce(getFlattenedRequiredFields, []).filter(function (name) { return !get(form, name); });
    };
    return FormState;
}());
export { FormState };
